import {useVscContext} from "../../content/VscReactContext";
import {useEffect, useState} from "react";

import {IModelConfig, IModelConfigData, IViewpointGroup, IViewpointGroupJson} from "../../../data/IViewpoint";

export function getItemsForTab(tabName:string, modelConfig: IModelConfig | null) {
    if (modelConfig === null) return [];
    return modelConfig.views.find(v => v.name === tabName)?.items ?? [];
}
export function useModelConfig(modelId: string) {
    const vscContext = useVscContext();
    const modelConfigUrl = vscContext.getHtmlContentUri("_config/models/" + modelId + ".json");

    const [modelConfig, setModelConfig] = useState<IModelConfig | null>(null);
    useEffect(() => {
        let useResponse = true;
        const f = async () => {

            const modelResponse = await fetch(modelConfigUrl);
            const modelJson = await modelResponse.json() as IModelConfig;
            if (modelJson.viewpointGroup) {
                const viewPointGroupResponse = await fetch(vscContext.getHtmlContentUri("_config/models/" + modelJson.viewpointGroup));
                const viewpointGroup = await viewPointGroupResponse.json();
                modelJson.viewpointGroupDefinition = (viewpointGroup as IViewpointGroupJson)?.ViewpointGroup;
            }
            if (useResponse) {
                setModelConfig(modelJson);
            }
        }
        f();
        return () => {
            useResponse = false;
        }
    }, [modelConfigUrl]);
    return modelConfig;
}